import axios, { AxiosError } from 'axios';
import { useAuthStore } from '../auth/auth-store';

const baseURL = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:23015';

export const apiClient = axios.create({
  baseURL,
  withCredentials: false,
});

apiClient.interceptors.request.use((config) => {
  const token = useAuthStore.getState().accessToken;
  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (res) => res,
  (err: AxiosError<{ message?: string | string[] }>) => {
    if (err.response?.status === 401) {
      useAuthStore.getState().clear();
    }
    // バックエンドが返す意味のあるメッセージ(例: 重複名 → 409「その値は既に使われています…」)を
    // 画面に出せるよう err.message へ載せ替える。これが無いと axios 既定の
    // "Request failed with status code 409/500" がそのまま表示されてしまう。
    const apiMessage = err.response?.data?.message;
    if (apiMessage) {
      err.message = Array.isArray(apiMessage) ? apiMessage.join(' / ') : apiMessage;
    }
    return Promise.reject(err);
  },
);
